async function buildCompleteTheSetInCart() {

  const cartItems = document.querySelectorAll('cart-items .cart-item:not(.fake-cart-item)')
  let completeTheSetProducts, referenceProductId = null

  if (!cartItems) return

  for (const cartItem of cartItems) {
    const json = JSON.parse(cartItem.dataset.json)
    const productRecommendationFetchUrl = `${window.Shopify.routes.root}recommendations/products.json?product_id=${json.product_id}&limit=6&intent=complementary`
    const response = await fetch(productRecommendationFetchUrl)
    const data = await response.json()
    if (data && data.products.length > 0) {
      completeTheSetProducts = data.products
      referenceProductId = json.product_id
      break
    }
  }

  let upsellHeaderTarget = document.querySelector('cart-upsells ul .tab-item a[data-heading="You May Also Like"]')
  const upsellProductContainer = document.querySelector('cart-upsells .tab-content .swiper[data-heading-target="You May Also Like"]')

  if (!upsellHeaderTarget || !upsellProductContainer || !completeTheSetProducts || !referenceProductId) return

  let swiperJson = JSON.parse(upsellProductContainer.dataset.json)

  swiperJson.scrollbar.el = '.swiper-scrollbar--complete-the-set'
  upsellHeaderTarget.setAttribute('data-href', 'complete-the-set')

  upsellHeaderTarget.innerText = 'Complete the Set'

  // build and init swiper inside that specific upsellProductContainer

  const swiperContainer = document.createElement('div')
  const swiperWrapper = document.createElement('div')
  const swiperScrollbar = document.createElement('div')

  swiperContainer.classList = 'swiper complete-the-set'
  swiperContainer.setAttribute('data-target', 'complete-the-set')
  swiperContainer.setAttribute('data-json', JSON.stringify(swiperJson))
  swiperWrapper.classList = 'horizontal-scroller__upsell swiper-wrapper'
  swiperScrollbar.classList = 'swiper-scrollbar swiper-scrollbar--complete-the-set'

  completeTheSetProducts.forEach((product) => {

    if(!product.available || product.id == referenceProductId) return

    const titleParts = product.title.split('|')
    const primaryTitle = titleParts[0].trim()
    const subtitleHtml = titleParts.length > 1
      ? `<div class="card-information"><small class="card__seo-text no-seo-tag" style="margin-top: 0.5rem;">${titleParts[1].trim()}</small></div>`
      : ''

    const productHtml = `
      <upsell-item class="upsell cts relative swiper-slide" data-title="${product.title}">
        <a data-id="${product.variants[0].id}" href="/products/${product.handle}" class="quick-add-btn link--fill-parent seventy">
          <span class="visually-hidden">Link to ${product.title}</span>
        </a>
        <div class="upsell__image">
          <img src="${product.featured_image}" width="100%" alt="${product.title}">
          <svg class="icon-plus" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="black"/>
            <path d="M7.37255 7.37255V4H8.60784V7.37255H12V8.60784H8.60784V12H7.37255V8.60784H4V7.37255H7.37255Z" fill="black"/>
          </svg>
        </div>
        <h3 class="card__heading carlson-semibold">
            <a href="${product.url}">
              <div class="upsell__title">${primaryTitle}</div>
            </a>
            <div class="upsell__price">${formatPrice(product.price)}</div>
        </h3>
        ${subtitleHtml}
      </upsell-item>
    `
    swiperWrapper.innerHTML += productHtml
  })

  swiperContainer.appendChild(swiperWrapper)
  swiperContainer.appendChild(swiperScrollbar)

  upsellProductContainer.parentElement.prepend(swiperContainer)
  upsellProductContainer.remove()

  const swiper = new Swiper('.complete-the-set', swiperJson)
  swiper.init()
}

function formatPrice(price) {
  if(!price) return ''  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price / 100)
}

class InspiredAppOpener extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick)
  }

  handleClick = () => {
    const widget = document.querySelector('inspired-floating-widget')
    const shadowRoot = widget?.shadowRoot
    if (!shadowRoot) return
    shadowRoot.querySelector('.inspired-floating').click()
  }
}

customElements.define('inspired-app-opener', InspiredAppOpener)

function initImgModelHeight() {
  const desktopImgContainer = document.querySelector('li.grid__item:has(img[alt*="Model height"])')
  const mobileImgContainer = document.querySelector('#product__mobile-images .mobile-img-slide:has(img[alt*="Model height"]) .media')
  let contentDesktop
  let contentMobile

  if(desktopImgContainer) {
    contentDesktop = desktopImgContainer.querySelector('img').getAttribute('alt')
    desktopImgContainer.style.setProperty("--content", `"${contentDesktop}"`);
  }
  if(mobileImgContainer) {
    contentMobile = mobileImgContainer.querySelector('img').getAttribute('alt')
    mobileImgContainer.style.setProperty("--content", `"${contentMobile}"`);
  }
}

function setRecentlyViewedNav(refreshingStorage = true) {
  
  const recentlyViewedButton = document.querySelector('.recently-viewed-button')
  const recentlyViewedCount = recentlyViewedButton?.querySelector('.recently-viewed-count')
  const recentlyViewedNav = document.querySelector('.recently-viewed-nav')
  const recentlyViewedNavList = recentlyViewedNav?.querySelector('.recently-viewed-products-list')
  const mobileCloseButton = recentlyViewedNav?.querySelector('#rv-close')

  if (!recentlyViewedButton || !recentlyViewedCount || !recentlyViewedNav) return

  const storage = JSON.parse(localStorage.getItem('_rv'))
  const currentCount = storage.length || 0

  if(currentCount === 0) {
    recentlyViewedCount.classList.add('hidden')
    recentlyViewedCount.innerText = '0'
    // set state of nav 
    return
  }

  storage.reverse() // to show the most recent first

  // set up nav

  const targetUl = document.querySelector('.recently-viewed-nav .recently-viewed-products-list')
  const targetLis = document.querySelectorAll('.recently-viewed-nav .recently-viewed-products-list li')

  targetLis?.forEach((el) => el.remove())

  storage.forEach((product, i) =>{    
    if(i >= 6) return
    targetUl.innerHTML += `
      <li>
        <div class="recently-viewed-card">
            <a href="/products/${product.handle}">
              <img src="${product.featured_image}" alt="Recently Viewed Product">
              <div class="info-container">
                <div class="price-title">
                  <h3 class="product-title">${product.product_title_type}</h3>
                  <h3 class="product-price">${window.formatPrice(product.price)}</h3>
                </div>
                <p class="color-descriptor">${product.product_title_color_descriptor}</p>
              </div>
            </a>
        </div>
      </li>
    `
  })

  // needed to add this check as when the function is called on storage update, it was adding multiple event listeners
  if(!refreshingStorage) {
    recentlyViewedButton.addEventListener('click', (e) => {
      e.preventDefault()
      recentlyViewedNav.classList.remove('hidden')
    })
    recentlyViewedButton.addEventListener('mouseenter', () => {
      recentlyViewedNav.classList.remove('hidden')
    })
    recentlyViewedNav.addEventListener('mouseleave', () => {
      recentlyViewedNav.classList.add('hidden')
    })
    mobileCloseButton?.addEventListener('click', (e) => {
      e.preventDefault()
      recentlyViewedNav.classList.add('hidden')
    })
  }

  recentlyViewedCount.classList.remove('hidden')
  recentlyViewedCount.innerText = currentCount

}

class xGenSearchResult extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', this.trackClick)
  }
  trackClick() {

    const query = this.dataset.query
    const queryId = this.dataset.queryId
    const deploymentId = this.dataset.deploymentId
    const item = this.dataset.item
  
    if(!query || !queryId || !deploymentId || !item) return

    xg.track.pageView({ locale: "en_US"})
    xg.track.searchClick({
      query, 
      queryId, 
      deploymentId, 
      item,
      locale: "en_US"})
  } 
}

customElements.define('x-gen-search-result', xGenSearchResult)

window.buildCompleteTheSetInCart = buildCompleteTheSetInCart
window.formatPrice = formatPrice
window.initImgModelHeight = initImgModelHeight
window.setRecentlyViewedNav = setRecentlyViewedNav
